import React from 'react';
import {
  makeStyles,
  Card,
  Typography,
  Grid,
  Button
} from '@material-ui/core/';

const useStyles = makeStyles(() => ({
    root: {
      maxWidth: 650,
      height: 500,
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      margin: '-5% 0% 5% 0%',
      zIndex:2,
      textAlign: 'center',
      padding: '2% 0%',
    },
    iFrame: {
      width: '100%',
      height: '100%',
    },
  }));

  function IFrame() {
    const classes = useStyles();

    return(
        <Card className={classes.root}>
            <Typography style={{padding: '2%'}} gutterBottom variant="h4" color='textSecondary' >
                REZERVAČNÍ KALENDÁŘ
            </Typography>
            <Typography gutterBottom style={{width: '80%'}} variant='body2' color='textPrimary'>
                Rezervaci můžete předběžně provést telefonicky a následně ji potvrdit emailem.<br />
                Jakmile obržíme objednávku budeme držet rezervaci po dobu maximálně 7 dnů.<br />
                V tomto čase je potřeba uhradit zálohu ve výši 50 %  z celkové ceny na bankovní účet a objednávka se stává platnou.<br />
                Veškeré podklady pro platbu Vám budou zaslány v potvrzovacím emailu Vaší objednávky.
            </Typography> 
            <Typography gutterBottom variant='body1' color='error'>
                Červeně označené dny v rezervačním kalendáři jsou již obsazeny.
            </Typography>
            <Grid item style={{width:'100%'}}>
                <iframe className={classes.iFrame} src="https://obsazenost.e-chalupy.cz/kalendar.php?id=8224" frameBorder={0}></iframe>
            </Grid>
        </Card>
    )
  }

  export default IFrame;